import { useQuery } from "@tanstack/react-query";

import { profileApi } from "@/features/profile/services/profile.api";

export function usePublicProfile(userId: string) {
  return useQuery({
    queryKey: ["profile", "public", userId],
    queryFn: () => profileApi.getPublicProfile(userId),
    enabled: Boolean(userId),
  });
}

export function useSellerListings(userId: string) {
  return useQuery({
    queryKey: ["profile", "listings", userId],
    queryFn: () => profileApi.getSellerListings(userId),
    enabled: Boolean(userId),
  });
}
